import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=c7f125c8&scoped=true&"
import script from "./FormSubmissions.vue?vue&type=script&lang=ts&"
export * from "./FormSubmissions.vue?vue&type=script&lang=ts&"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=c7f125c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f125c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
